export default "__VITE_ASSET__BytsyAYi__"